import React from 'react'
import { Carousel } from 'react-responsive-carousel';
import s1 from "../assets/s1.jpg";
import s2 from "../assets/s2.jpg";
import s3 from "../assets/s3.jpg";
import s4 from "../assets/s4.jpg";
import s5 from "../assets/s5.jpg";
import s6 from "../assets/s6.jpg";
import s7 from "../assets/s7.jpg";
import s8 from "../assets/s8.jpg";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const Services = () => {
  return (
    <div>
<Carousel showThumbs={false} infiniteLoop autoPlay showStatus={false} showArrows={false} interval={2000}>
    <div>
        <img src={s1} alt='item1'/>
        
    </div>

    <div>
        <img src={s3} alt='item3'/>
        
    </div>

    <div>
        <img src={s2} alt='item2'/>
        
    </div>

    <div>
        <img src={s4} alt='item4'/>
        
    </div>

    <div>
        <img src={s5} alt='item5'/>
        
    </div>

    <div>
        <img src={s6} alt='item5'/>
        
    </div>

    <div>
        <img src={s7} alt='item5'/>
        
    </div>

    <div>
        <img src={s8} alt='item5'/>
        
    </div>
</Carousel>
    </div>
  );
};

export default Services;